import React from "react";

export function RemoveColumnFormatter(cellContent,row,rowIndex, {clientsToRemove}){

    const getAction = () => {
        const currClient = clientsToRemove.find(client => client == row._id)
        if(currClient) {
            return (
                <button
                    type="button"
                    className="btn btn-primary font-weight-bolder font-size-sm mr-1"
                >
                    Selected
                </button>
            )
        } else {
            return (
                <button
                    type="button"
                    className="btn btn-primary font-weight-bolder font-size-sm mr-1"
                >
                    <i className="fa fa-trash"></i>
                </button>
            )
        }
        
    }

    return(
        <>
            {getAction()}
        </>
    )
}